import type {ReactNode} from "react";
import {Label} from "@/components/ui/label";

type Props = {label: string; children: ReactNode; className?: string};

export function AdminField({label, children, className}: Props) {
  return (
    <label className={`admin-field${className ? ` ${className}` : ""}`}>
      <Label className="admin-field__label">{label}</Label>
      <div className="admin-field__control">{children}</div>
    </label>
  );
}
